import { render, staticRenderFns } from "./ExamModeEditor.vue?vue&type=template&id=5b950ace&scoped=true&"
import script from "./ExamModeEditor.vue?vue&type=script&lang=ts&"
export * from "./ExamModeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExamModeEditor.vue?vue&type=style&index=0&id=5b950ace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b950ace",
  null
  
)

export default component.exports